import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { Component, OnInit } from "@angular/core";
import { MatChipInputEvent } from "@angular/material/chips";
import { Router } from "@angular/router";
import { AlertController } from "@ionic/angular";
import { STORAGE } from "src/app/constant/storages";
import { ApiserviceService } from "src/app/httpservice/apiservice.service";
import { AppService } from 'src/app/services/app.service';
import { _deleteStorage, _setStorage } from "src/app/utils/local-storage";

export interface Phones {
  numbers: string;
}

@Component({
  selector: "app-no-taxinvoice",
  templateUrl: "./no-taxinvoice.component.html",
  styleUrls: ["./no-taxinvoice.component.scss"],
})
export class NoTaxinvoiceComponent implements OnInit {
  phone: any = "";
  taxid: any = "";
  company_name: any = "";
  count = 0;

  constructor(
    public alertController: AlertController,
    public apiservice: ApiserviceService,
    public router: Router,
    public appService: AppService,

  ) {
    this.appService.setActive(1);
    this.company_name = "";
    this.phone = "";
    this.phones = [];

    _deleteStorage(STORAGE.DATA_SELECT_NO_TAXINVOICE)
    _deleteStorage(STORAGE.DATA_ADD_NO__TAXINVOICE)
    _deleteStorage(STORAGE.DATA_EDIT_NO__TAXINVOICE)
    _deleteStorage(STORAGE.DATA_PREVIEW_NO__TAXINVOICE)
  }

  ngOnInit() {}

  ionViewDidEnter(){
    this.company_name = "";
    this.phone = "";
    this.phones = [];
  }

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  phones: Phones[] = [];

  add(e: MatChipInputEvent): void {
    this.checkphone({ code: "ENTER", key: " " }, 1);

    // console.log("eeeee", e);
    const input = e.input;
    const value = e.value;

    // Add our fruit
    if ((value || "").trim()) {
      this.phones.push({ numbers: value.trim() });
    }

    // Reset the input value
    if (input) {
      input.value = "";
    }
  }

  remove(phone: Phones): void {
    const index = this.phones.indexOf(phone);

    if (index >= 0) {
      this.phones.splice(index, 1);
      this.phone = "";
    }
  }
  async checkphone(e, n) {
    let phone = [];
    phone = this.phone;
    if (e.code && e.code.toUpperCase() === "ENTER") {
      if (phone.length != 10 && phone.length != 9) {
        const alert = await this.alertController.create({
          cssClass: "my-confirm-phone",
          message: "กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง",
        });
        await alert.present();
        setTimeout(() => {
          alert.dismiss(true);
          this.phones = this.phones.slice(0, -1);
        }, 1500);
      }
    } else {
      if (n == 1) {
        this.phone = e.target.value.match(/[0-9]*/)[0];
      }
    }
  }
  async search() {
    let isConfirm: boolean = false;
    let phones = [];

    for (let i of this.phones) {
      phones.push(i.numbers);
    }

    if (!isConfirm) {
      if (String(this.phone) === "" && this.company_name === "") {
        const alert = await this.alertController.create({
          cssClass: "my-custom-class",
          message: "กรุณาระบุอย่างน้อยหนึ่งช่อง",
          buttons: [
            {
              text: "OK",
              cssClass: "alertButton",
              handler: (blah) => {},
            },
          ],
        });
        await alert.present();
      } else {
        isConfirm = true;
      }
    }
    if (isConfirm) {
      const data = {
        searchCustomerData: {
          searchMode: "FULLTAXNOTAXID",
          phone: phones,
          taxid: "",
          company_name: this.company_name,
        },
      };
      console.log("[---data confirm post api-----]", data);

      try {
        this.apiservice
          ._post(this.apiservice.apiUrl + this.apiservice.searchcustomer, data)
          .then(async (res: any) => {
            console.log("RES SERCH NO TAX INVOICE ========:",res)
            if (res.statusCode === 200) {
              _setStorage(STORAGE.DATA_SELECT_NO_TAXINVOICE,res.data)
              this.router.navigate(["/select-no-taxinvoice"], {
                queryParams: { noName: "no_tax", selectedIndex: "4" },
              });
            } else if (res.statusCode === 204) {
              _setStorage(STORAGE.DATA_SELECT_NO_TAXINVOICE,[])
              _setStorage(STORAGE.DATA_SEARCH_NO__TAXINVOICE,data)

              this.router.navigate(["/select-no-taxinvoice"], {
                queryParams: { noName: "no_tax", selectedIndex: "4" },
              });
            } else {
              this.errorMsg(res.statusMessage)
            }
          });
      } catch (error) {
        // console.log(error);
      
      } 
    }
  }
  async errorMsg(message: string) {
    let alert = await this.alertController.create({
      cssClass: "my-custom-class",
      message: message,
      buttons: [
        {
          text: "OK",
          cssClass: "alertButton",
          handler: (blah) => {
            //
          },
        },
      ],
    });
    await alert.present();
  }
}
